import { type NextSeoProps } from 'next-seo';
import { useIntl } from '@doxyme/locale';
import { type RoomForPatient } from '../../services';
import { useRoomHostName } from '../useRoomHostName';
import { usePatientPaidStatus } from '../../hooks/usePatientPaidStatus';

export const useCheckInSeo = (room?: RoomForPatient | null): NextSeoProps => {
  const roomSlug = room?.slug;

  const { formatMessage } = useIntl();

  const { freeOrPaid } = usePatientPaidStatus(roomSlug);
  const provider = useRoomHostName(room);

  const roomUrl = `${window.location.origin}/${roomSlug}`;

  return {
    title: Boolean(provider)
      ? formatMessage({ id: 'checkIn.meta.title' }, { provider })
      : undefined,
    description: formatMessage(
      { id: 'patient.meta.description' },
      { provider },
    ),
    openGraph: {
      type: 'website',
      images: [{ url: `${window.location.origin}/assets/images/og-image.jpg` }],
      url: roomUrl,
      title: formatMessage(
        {
          id: `patient.meta.og.title.${freeOrPaid}`,
        },
        { provider },
      ),
      description: formatMessage(
        {
          id: `patient.meta.og.description.${freeOrPaid}`,
        },
        { roomUrl },
      ),
    },
    twitter: {
      cardType: 'summary_large_image',
    },
    noindex: true,
    nofollow: true,
  };
};
